import React from 'react';

const ShippingInfo = ({ data }) => {
  return (
    <div className="shipping-info">
      <div>
        <strong>PORT OF LOADING</strong><br/>
        {data.portOfLoading}
      </div>
      <div>
        <strong>FINAL DESTINATION</strong><br/>
        {data.finalDestination}
      </div>
      <div>
        <strong>Carrier</strong><br/>
        {data.carrier}
      </div>
      <div>
        <strong>ETD/SAILING DATE</strong><br/>
        {data.sailingDate}
      </div>
    </div>
  );
};

export default ShippingInfo;